import React from "react";
import { Box, TextField, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";

type Props = {
  phone: string;
  marketingOptIn: boolean;
  onPhoneChange: (phone: string) => void;
  onMarketingChange: (optIn: boolean) => void;
};

export function OwnerPhoneQuestion({
  phone,
  marketingOptIn,
  onPhoneChange,
  onMarketingChange,
}: Props) {
  return (
    <QuestionCard
      title="Your phone number"
      subtitle="Optional - for delivery updates"
      field="ownerPhone"
    >
      <TextField
        placeholder="+44 7..."
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        autoComplete="tel"
        inputMode="tel"
        type="tel"
        fullWidth
        variant="outlined"
        sx={{
          maxWidth: 400,
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            padding: 0,
            "& fieldset": { border: "2px solid #7B3306" },
            "&:hover fieldset": { border: "2px solid #7B3306" },
            "&.Mui-focused fieldset": {
              border: "2px solid #4A90E2",
              boxShadow: "0 0 8px rgba(74,144,226,0.35)",
            },
          },
          "& .MuiInputBase-input": {
            backgroundColor: "#FFFFFF",
            padding: { xs: "16px 14px", sm: "18px 14px" },
            fontWeight: 500,
            fontSize: { xs: "16px", sm: "15px" },
            lineHeight: 1.2,
            color: "#4A3026",
            textAlign: "center",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A06B4D",
            opacity: 0.7,
          },
        }}
      />

      {/* Marketing Opt-in */}
      <Box sx={{ mt: 3, maxWidth: 400 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={marketingOptIn}
              onChange={(e) => onMarketingChange(e.target.checked)}
              size="small"
              sx={{
                color: "#7B3306",
                "&.Mui-checked": {
                  color: "#9AE600",
                },
              }}
            />
          }
          label={
            <Typography
              sx={{
                fontSize: { xs: 12, sm: 13 },
                color: "#4A301E",
                lineHeight: 1.35,
              }}
            >
              Yes - send me offers and tips by email (unsubscribe anytime)
            </Typography>
          }
        />
      </Box>

      {/* Fun fact with dog illustration */}
      <Box
        sx={{
          mt: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src="https://cdn.shopify.com/s/files/1/0946/0622/9844/files/Group_1.png?v=1765158922"
          alt="Dog"
          sx={{ width: { xs: 60, sm: 80 } }}
        />
        <Typography
          sx={{
            fontSize: { xs: 12, sm: 13 },
            color: "#A06B4D",
            maxWidth: 200,
            lineHeight: 1.35,
          }}
        >
          Dogs can recognise over <b>100 human words</b> - yours knows you best!
        </Typography>
      </Box>
    </QuestionCard>
  );
}
